import { FoundersSelection } from '@/models/founder-item.model';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FoundersService {
  BaseUrl = environment.landmark_API_URL + '/founders';

  constructor(private http: HttpClient) { }

  getLists() {
    return this.http.get(`${this.BaseUrl}/lists`);
  }

  getSlots() {
    return this.http.get(`${this.BaseUrl}/slots`);
  }
  saveList(list: FoundersSelection[]) {
    return this.http.post(`${this.BaseUrl}/batchupdate`, list);
  }
  
}
